/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./prints.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "@angular/router";
import * as i3 from "./prints.component";
var styles_PrintsComponent = [i0.styles];
var RenderType_PrintsComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_PrintsComponent, data: {} });
export { RenderType_PrintsComponent as RenderType_PrintsComponent };
export function View_PrintsComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), i1.ɵdid(1, 212992, null, 0, i2.RouterOutlet, [i2.ChildrenOutletContexts, i1.ViewContainerRef, i1.ComponentFactoryResolver, [8, null], i1.ChangeDetectorRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_PrintsComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-prints", [], null, null, null, View_PrintsComponent_0, RenderType_PrintsComponent)), i1.ɵdid(1, 114688, null, 0, i3.PrintsComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var PrintsComponentNgFactory = i1.ɵccf("app-prints", i3.PrintsComponent, View_PrintsComponent_Host_0, {}, {}, []);
export { PrintsComponentNgFactory as PrintsComponentNgFactory };
